<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="px-0 px-sm-3">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        border-variant="dark"
        class="main-card"
      >
        <template #header class="card-header px-0">
          <router-link to="/member/settings/bank">
            <i class="fas fa-chevron-left"></i> ย้อนกลับ
          </router-link>
        </template>
        <b-row>
          <b-col cols="7" sm="7" md="8" lg="9" xl="10" class="px-2">
            <h5 class="d-inline">
              <i class="fas fa-folder-plus"></i> เพิ่มบัญชีธนาคาร
            </h5>
            <small class="d-inline-block">(เติมเครดิตครั้งแรก และเพิ่มบัญชีธนาคารอื่นๆ)</small>
          </b-col>
          <b-col cols="5" sm="5" md="4" lg="3" xl="2" class="px-2 text-right">
            <b-button variant="primary" size-sm to="/member/settings/bank/status">
              <small>
                <i class="fas fa-search"></i> เช็คสถานะบัญชี
              </small>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="px-2">
            <div class="w-100 mt-2 mb-3 border-bottom"></div>
          </b-col>
        </b-row>
        <b-form v-on:submit="addBank($event)">
          <b-row>
            <b-col cols="12" md="6" lg="6" xl="6" class="mb-3 px-2">
              <label class="text-secondary">
                <i class="fas fa-university"></i> เลือกธนาคาร
              </label>
              <v-select
                :options="banks"
                v-model="webSelected"
                placeholder="กรุณาเลือกธนาคาร"
              >
                <template v-slot:selected-option="option">
                  <b-img
                    :src="option.logo"
                    height="22"
                    width="22"
                    class="mr-2 bank-icon"
                    :style="'background-color: ' + option.color"
                  />
                  <b-badge variant="light" class="mr-2">{{option.code}}</b-badge>
                  ธ.{{ option.title }}
                </template>
                <template v-slot:option="option">
                  <b-img
                    :src="option.logo"
                    height="22"
                    width="22"
                    class="mr-2 bank-icon"
                    :style="'background-color: ' + option.color"
                  />
                  <b-badge variant="light" class="mr-2">{{option.code}}</b-badge>
                  ธ.{{ option.title }}
                </template>
              </v-select>
            </b-col>
            <b-col cols="12" md="6" lg="6" xl="6" class="mb-3 px-2">
              <label class="text-secondary">
                <i class="fas fa-id-card"></i> ชื่อบัญชี
              </label>
              <b-form-input
                v-model="profile.bankAccountName"
                :value="profile.bankAccountName"
                placeholder="ชื่อบัญชี"
                readonly
              ></b-form-input>
            </b-col>
            <b-col cols="12" md="6" lg="6" xl="6" class="mb-3 px-2">
              <label class="text-secondary">
                <i class="fas fa-clipboard-check"></i> เลขที่บัญชี
              </label>
              <b-form-input v-model="accNo" placeholder="ระบุเฉพาะตัวเลข" required v-mask="'###-#-#####-#####'"></b-form-input>
            </b-col>
            <b-col cols="12" md="6" lg="6" xl="6" class="mb-3 px-2">
              <label class="text-secondary">
                <i class="fas fa-check-double"></i> ยืนยันเลขที่บัญชี
              </label>
              <b-form-input
                v-model="confirmAccNo"
                placeholder="ยืนยันเลขที่บัญชีอีกครั้ง"
                required
                v-mask="'###-#-#####-#####'"
              ></b-form-input>
            </b-col>
            <b-col cols="12" class="px-2">
              <b-alert variant="danger" :show="errmessage !== null">
                {{errmessage}}
              </b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="px-2">
              <div class="w-100 mt-3 mb-3 border-bottom"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6" class="px-2">
              <b-button variant="secondary" block type="button" @click="webSelected = []; accNo = null; confirmAccNo = null;">ยกเลิก</b-button>
            </b-col>
            <b-col cols="6" class="px-2">
              <b-button variant="success" block type="submit">เพิ่มบัญชี</b-button>
            </b-col>
          </b-row>
        </b-form>
        <b-row>
          <b-col class="px-2">
            <div class="w-100 mt-4 mb-3 border-bottom"></div>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";

export default {
  name: "AddBankAcc",
  components: {
    TopBarMember,
    FooterIndex
  },
  data() {
    return {
      errmessage: null,
      webSelected: [],
      profile: [],
      accNo: null,
      confirmAccNo: null,
      banks: [
        {
          bankID: 1,
          code: "BBL",
          title: "กรุงเทพ",
          logo: require('../../../../assets/images/bank-icon/bbl.svg'),
          color: "#1e4598"
        },
        {
          bankID: 2,
          code: "KBANK",
          title: "กสิกรไทย",
          logo: require('../../../../assets/images/bank-icon/kbank.svg'),
          color: "#138f2d"
        },
        {
          bankID: 3,
          code: "KTB",
          title: "กรุงไทย",
          logo: require('../../../../assets/images/bank-icon/ktb.svg'),
          color: "#1ba5e1"
        },
        {
          bankID: 4,
          code: "SCB",
          title: "ไทยพาณิชย์",
          logo: require('../../../../assets/images/bank-icon/scb.svg'),
          color: "#4e2e7f"
        },
        {
          bankID: 5,
          code: "BAY",
          title: "กรุงศรีอยุธยา",
          logo: require('../../../../assets/images/bank-icon/bay.svg'),
          color: "#fec43b"
        },
        {
          bankID: 6,
          code: "CIMB",
          title: "ซีไอเอ็มบี",
          logo: require('../../../../assets/images/bank-icon/cimb.svg'),
          color: "#7e2f36"
        },
        {
          bankID: 7,
          code: "GSB",
          title: "ออมสิน",
          logo: require('../../../../assets/images/bank-icon/gsb.svg'),
          color: "#eb198d"
        },
        {
          bankID: 8,
          code: "KIATNAKIN",
          title: "เกียรตินาคิน",
          logo: require('../../../../assets/images/bank-icon/kk.svg'),
          color: "#199cc5"
        },
        {
          bankID: 9,
          code: "LHBANK",
          title: "แลนด์ แอนด์ เฮาส์",
          logo: require('../../../../assets/images/bank-icon/lhb.svg'),
          color: "#6d6e71"
        },
        {
          bankID: 10,
          code: "STANDARD",
          title: "สแตนดาร์ดชาร์เตอร์ด (ไทย)",
          logo: require('../../../../assets/images/bank-icon/sc.svg'),
          color: "#0f6ea1"
        },
        {
          bankID: 11,
          code: "THANACHART",
          title: "ธนชาติ",
          logo: require('../../../../assets/images/bank-icon/tbnk.svg'),
          color: "#fc4f1f"
        },
        {
          bankID: 12,
          code: "TISCO",
          title: "ทิสโก้",
          logo: require('../../../../assets/images/bank-icon/tisco.svg'),
          color: "#12549f"
        },
        {
          bankID: 13,
          code: "TMB",
          title: "ทหารไทย",
          logo: require('../../../../assets/images/bank-icon/tmb.svg'),
          color: "#1279be"
        },
        {
          bankID: 14,
          code: "UOB",
          title: "ยูโอบี",
          logo: require('../../../../assets/images/bank-icon/uob.svg'),
          color: "#0b3979"
        }
      ]
    };
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      axios
        .post(
          this.getApiUrl + "/customer/getcurrentfinance",
          {
            username: this.getUsername
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          this.profile = response.data.data;
          this.profile.bankAccountName =  this.profile.firstName + ' ' + this.profile.lastName;
        });
    },
    addBank(e) {
      this.errmessage = null;
      e.preventDefault();
      if(this.webSelected.length == 0) {
        this.errmessage = "กรุณาเลือกบัญชีธนาคาร";
      }
      else if(this.accNo != this.confirmAccNo) {
        this.errmessage = "เลขที่บัญชีไม่ตรงกัน";
      }
      else {
        axios
        .post(
          this.getApiUrl + "/cash/addBankAccount",
          {
            username: this.getUsername,
            accountNo: this.accNo.replace(/-/g, ""),
            bankID: this.webSelected.bankID,
            accountName: this.profile.bankAccountName
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          this.$router.push("/member/settings/bank");
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  }
}
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.acc-name {
  line-height: 35px;
}

.avatar-preview {
  border-radius: 50px;
  overflow: hidden;
  height: 80px;
  width: 80px;
}

.button-upload-file {
  position: relative;
  cursor: pointer;

  input {
    width: 1px;
    height: 1px;
    display: block;
    position: absolute;
    top: -100%;
    left: -100%;
  }

  .icon {
    height: 32px;
    width: 32px;
    background: #3b5898;
    position: absolute;
    z-index: 2;
    bottom: 0px;
    right: 0px;
    text-align: center;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    padding: 5px 0px 0px 1px;
  }
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.credit-balance {
  background-color: #d4edda !important;
  border-color: #c3e6cb;
  font-size: 30px;
  line-height: 40px;
  height: 48px;

  :focus {
    outline: none;
  }
}

.input-hidden {
  position: absolute;
  left: -9999px;
}

.bank-icon {
  padding: 3px;
}

.bank-logo {
  padding: 10px;
}

.check-icon {
  position: absolute;
  bottom: 9px;
  left: 17px;
  border: 2px #fff solid;
  padding: 2px 4px 0px 5px;
}
</style>